import React, { Component } from 'react'
import Box from "@mui/material/Box";
import CarbonFootprintTab from '../components/carbon_footprint/CarbonFootprintTab';
import TakeAction from '../components/carbon_footprint/TakeAction';
import CarbonFootprintForm from '../components/carbon_footprint/CarbonFootprintForm';
export class CarbonFootprint extends Component {

    constructor(props) {
        super(props);
        this.state = {
          isReady: false,
          isRegistered: false
        };
      }

      submitForm = () => {
        this.setState({
            isRegistered:true
        })
    }
    

    render() {
        return (
            <Box pb={5}>
                {
                    !this.state.isRegistered ? 
                    <Box className="cfFormWrapper">
                    <CarbonFootprintForm handleSubmit={this.submitForm} gid={this.props.gid} />
                    </Box>
                    :
                    this.props.tab === "carbon_footprint" ? <CarbonFootprintTab gid={this.props.gid} /> : <TakeAction gid={this.props.gid} /> 
                }
            </Box>
        )
    }
}

export default CarbonFootprint
